import { render, staticRenderFns } from "./Step_5v2.vue?vue&type=template&id=4303faa2&"
import script from "./Step_5v2.vue?vue&type=script&lang=ts&"
export * from "./Step_5v2.vue?vue&type=script&lang=ts&"
import style0 from "./Step_5v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports